export const SDK_VERSION = '7.50.0';
